import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "close-circle-outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-close-circle-outline',
    templateUrl: './icon-close-circle-outline.component.html',
    styleUrls: ['./icon-close-circle-outline.component.scss'],
    standalone: false
})
export class IconCloseCircleOutlineComponent  {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
